import React, { FC } from "react";
import { Datagrid, List, ListProps, TextField } from "react-admin";

const MailList: FC<ListProps> = (props) => (
  <List bulkActionButtons={false} {...props} pagination={false}>
    <Datagrid rowClick="edit">
      <TextField source="name" display={"initial"} sortable={false} />
      <TextField source="id" sortable={false} />
    </Datagrid>
  </List>
);

export default MailList;
